import { useFormContext } from 'react-hook-form'

import { FormError, SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface CounterpartyIdFormFieldProps {
  counterparties?: { label: string; value: number }[]
  loading?: boolean
}

export const CounterpartyIdFormField: React.FC<CounterpartyIdFormFieldProps> = ({
  counterparties,
  loading,
}) => {
  const { control, setValue } = useFormContext<{ counterparty_id: number }>()

  return (
    <FormField
      name="counterparty_id"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Counterparty</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              placeholder={'Select a Counterparty'}
              value={field.value?.toString()}
              loading={loading}
              setValue={(val) =>
                setValue('counterparty_id', parseInt(val), {
                  shouldValidate: true,
                })
              }
              options={counterparties?.map(({ label, value }) => ({
                label,
                value: value?.toString(),
              }))}
            />
          </FormItem>
        )
      }}
    />
  )
}
